import { Checkbox, CircularProgress, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';

class BloqueioBaixa extends ReactComponent {
    salvando = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            salvando: observable,
            registro: computed,
            bloqueioBaixa: computed,
            toggleBloqueioBaixa: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get bloqueioBaixa() {
        return this.registro.bloqueioBaixa;
    }

    toggleBloqueioBaixa = async () => {
        this.salvando = true;

        try {
            const result = await this.processoService.bloquearBaixa(
                this.sessaoStore.idSessaoSelecionada,
                this.registro
            );

            runInAction(() => {
                if (result !== this.registro.bloqueioBaixa) {
                    this.registro.bloqueioBaixa = result;

                    if (this.salaSessaoStore.isProcessoPje(this.registro)) {
                        this.atualizarChipRemessaBloqueada(result);
                    }
                } else {
                    this.mensagemStore.abrirMensagemErro('Ocorreu um erro ao alterar o bloqueio da baixa.');
                }
            });
        } finally {
            runInAction(() => {
                this.salvando = false;
            });
        }
    };

    atualizarChipRemessaBloqueada(bloqueado) {
        const indicadores = this.registro.processo?.indicadores;

        if (!indicadores) return;

        const DESCRICAO_CHIP = 'Remessa bloqueada';
        const indice = indicadores.findIndex((ind) => ind.descricao === DESCRICAO_CHIP);

        if (bloqueado && indice === -1) {
            indicadores.push({ codigo: 325, descricao: DESCRICAO_CHIP, tramitacaoPreferencial: false, cor: 'Amarelo' });
        } else if (!bloqueado && indice !== -1) {
            indicadores.splice(indice, 1);
        }
    }

    render() {
        if (!this.isComponenteHabilitado('BloqueioBaixa')) {
            return null;
        }
        const carregando = this.registro.carregandoIndicadoresProcesso;

        return (
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.95rem' }}>
                {carregando ? (
                    <CircularProgress size={20} style={{ margin: '2px 10px' }} />
                ) : (
                    <Checkbox
                        size="small"
                        checked={this.registro.bloqueioBaixa}
                        onChange={this.toggleBloqueioBaixa}
                        disabled={this.salvando}
                        style={{ padding: '2px 10px' }}
                    />
                )}
                <Typography
                    style={{
                        color: this.bloqueioBaixa ? red[800] : '#01579b',
                        fontWeight: 'bold',
                        fontSize: '0.95rem'
                    }}
                >
                    {'Baixa automática bloqueada'}
                </Typography>
            </div>
        );
    }
}

export default inject('stores')(observer(BloqueioBaixa));
